// constants.js
export const Image_profiles = {
  PROFILE: "Profile",
  POST: "Post",
  PROJECT: "Project",
  ADVERTISEMENT: "Advertisement"
};

